import { LoanFormatState } from './state';

export const LOANFORMAT_CHANGE = 'LOANFORMAT_CHANGE';

export type LoanFormatChange = {
    type: typeof LOANFORMAT_CHANGE;
    payload: LoanFormatState;
};

export type LoanFormatAction = LoanFormatChange;
